<template>
  <v-container>
    <v-row
      v-if="enableDevolucaoClienteWeb"
      id="headersDevolucaoClientes"
    >
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="12"
      >
        <v-card
          id="cardDashbord"
          class="mx-auto"
          outlined
        >
          <div class="card-header-dashbord">
            <v-row>
              <v-col
                cols="12"
                sm="10"
                md="10"
                lg="10"
                class="d-flex flex-wrap"
              >
                Quais os clientes com maior devolução?
              </v-col>
              <v-col
                cols="12"
                sm="2"
                md="2"
                lg="2"
                class="d-flex justify-end"
              >
                <v-tooltip top>
                  <template
                    v-slot:activator="{ on, attrs }"
                  >
                    <v-icon
                      id="iconInformationFatxMetaComercial4"
                      class="text-left"
                      v-bind="attrs"
                      v-on="on"
                      @mouseover="enableTexto('167')"
                    >
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <div
                    v-if="codigo === '167'"
                    v-html="textoParticpantesDevolucao"
                  />
                </v-tooltip>
              </v-col>
            </v-row>
          </div>
          <v-card-actions>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <div
                  v-if="loading"
                  :style="styleObject"
                  class="text-center"
                >
                  <v-icon
                    light
                    class="custom-loader"
                    :style="styleObject"
                  >
                    mdi-cached
                  </v-icon>
                  Carregando dados...
                </div>
                <div
                  v-else-if="error"
                  class="alert alert-danger"
                >
                  {{ error }}
                </div>
                <div
                  v-else
                >
                  <div
                    id="idTable"
                    style="max-width: 100%;"
                  >
                    <table
                      style="width: 100%; overflow-x: auto; color: black; border-collapse: collapse;"
                      class="elevation-1"
                    >
                      <thead>
                        <tr>
                          <th
                            id="dadoMovimentacaoHeader"
                            style="text-align: center;"
                            class="black--text title"
                          >
                            Cliente
                          </th>
                          <th
                            id="dadoMovimentacaoHeader"
                            style="text-align: center;"
                            class="black--text title"
                          >
                            Valor da venda
                          </th>
                          <th
                            id="dadoMovimentacaoHeader"
                            style="text-align: center;"
                            class="black--text title"
                          >
                            Valor de devolução
                          </th>
                          <th
                            id="dadoMovimentacaoHeader"
                            style="text-align: center;"
                            class="black--text title"
                          >
                            % de devolução
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="item in devolucaoClientes"
                          :key="item.id"
                        >
                          <td
                            id="dadoMovimentacao"
                            style="text-align: left;"
                          >
                            {{ item.nome_cliente }}
                          </td>
                          <td
                            id="dadoMovimentacao"
                            style="text-align: right;"
                          >
                            {{ item.valor_venda }}
                          </td>
                          <td
                            id="dadoMovimentacao"
                            style="text-align: right;"
                          >
                            {{ item.valor_devolucao }}
                          </td>
                          <td
                            id="dadoMovimentacao"
                            style="text-align: right;"
                            :style="getColor(item.porcentagem)"
                          >
                            {{ item.porcentagem }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <router-link
                    to="/clientes/detalhe-cliente-dados-devolucoes"
                    :style="styleObject"
                  >
                    <div
                      id="linkDetalheClienteSemFaturamento"
                      class="text-center"
                    >
                      <v-icon
                        id="iconLinkClienteSemFaturamento"
                        class="text-center"
                      >
                        mdi-chevron-double-down
                      </v-icon><br>
                    </div>
                  </router-link>
                </div>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row
      v-if="enableDevolucaoClientePrint"
      id="devolucaoClientePrint"
    >
      <v-row id="devolucaoClientes">
        <v-col
          id="devolucaoClientes"
          cols="11"
          class="text-left"
        >
          <v-icon
            id="iconInformationDevolucaoClientes"
            class="text-left"
          >
            mdi-clipboard-arrow-left
          </v-icon>
          Quais os clientes com maior devolução?
        </v-col>
        <v-col
          cols="1"
          class="text-right"
        >
          <v-tooltip top>
            <template
              v-slot:activator="{ on, attrs }"
            >
              <v-icon
                id="iconInformationDevolucaoClientes"
                class="text-left"
                v-bind="attrs"
                v-on="on"
                @mouseover="enableTexto('167')"
              >
                mdi-information-outline
              </v-icon>
            </template>
            <div
              v-if="codigo === '167'"
              v-html="textoParticpantesDevolucao"
            />
          </v-tooltip>
        </v-col>
      </v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headersDevolucaoClientes"
          :items="devolucaoClientesPrint"
          :items-per-page="devolucaoClientesPrint.length"
          fixed-header
          disable-sort
          hide-default-footer
          class="elevation-1"
          style="color: black"
        >
          <template v-slot:[`item.nome_cliente`]="{ item }">
            <td>
              {{ item.nome_cliente }}
            </td>
          </template>
          <template v-slot:[`item.valor_venda`]="{ item }">
            <td
              class="text-right"
            >
              {{ item.valor_venda }}
            </td>
          </template>
          <template v-slot:[`item.valor_devolucao`]="{ item }">
            <td
              class="text-right"
            >
              {{ item.valor_devolucao }}
            </td>
          </template>
          <template v-slot:[`item.porcentagem`]="{ item }">
            <td
              class="text-right"
              :style="getColor(item.porcentagem)"
            >
              {{ item.porcentagem }}
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Clientes from '../../../../../services/clientes'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowClientesExibicaoMelhores',
    emits: ['envioDevolucao'],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      vendedorSelect: [],
      areaSelect: [],
      redeSelect: [],
      supervisorSelect: [],
      receita: [],
      segmento: [],
      categoria: [],
      promotor: [],
      headersDevolucaoClientes: [
        { text: 'Cliente', value: 'nome_cliente', class: 'black--text title' },
        { text: 'Valor da venda', value: 'valor_venda', align: 'right', class: 'black--text title' },
        { text: 'Valor de devolução', value: 'valor_devolucao', align: 'right', class: 'black--text title' },
        { text: '% de devolução', value: 'porcentagem', align: 'right', class: 'black--text title' },
      ],
      devolucaoClientes: [],
      devolucaoClientesPrint: [],
      enableDevolucaoClienteWeb: true,
      enableDevolucaoClientePrint: false,
      orientacao: JSON.parse(localStorage.getItem('orientacaoPartipantes')),
      codigo: 0,
      textoParticpantesDevolucao: '',
      width: '',
      dynamicPaddingDevolucao: '',
    }),

    created () {
      eventEmit.$on('set_faturamento_novos_clientes', this.handleUpdateDados)

      eventEmit.$on('enable-print', this.handleEnablePrint)

      eventEmit.$on('disable-print', this.handleDisablePrint)

      this.updateDynamicPadding()

      window.addEventListener('resize', this.updateDynamicPadding)
    },

    beforeDestroy () {
      eventEmit.$off('set_faturamento_novos_clientes', this.handleUpdateDados)

      eventEmit.$off('enable-print', this.handleEnablePrint)

      eventEmit.$off('disable-print', this.handleDisablePrint)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingDevolucao = 'padding-right: 32rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingDevolucao = 'padding-right: 10.6rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingDevolucao = 'padding-right: 4rem !important'
        } else {
          this.dynamicPaddingDevolucao = 'padding-right: 14rem !important'
        }
      },

      handleUpdateDados (primeiroDia, dataFinal, select, vendedor, area, rede, supervisor, receita, segmento, categoria, promotor) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select
        this.vendedorSelect = vendedor
        this.areaSelect = area
        this.redeSelect = rede
        this.supervisorSelect = supervisor
        this.receita = receita
        this.segmento = segmento
        this.categoria = categoria
        this.promotor = promotor

        this.showDadosDevolucaoClientes()
      },

      handleEnablePrint (value) {
        this.enableDevolucaoClientePrint = value
        this.enableDevolucaoClienteWeb = false
      },

      handleDisablePrint (value) {
        this.enableDevolucaoClientePrint = false
        this.enableDevolucaoClienteWeb = value
      },

      async showDadosDevolucaoClientes () {
        this.loading = true
        this.devolucaoClientes = []

        await Clientes.showDevolucaoClientes(this.primeiroDia, this.ultimoDia, this.select, localStorage.tokencontrato, this.vendedorSelect, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receita, this.segmento, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.devolucaoClientes = resposta.data.dadosDevolucaoClientes.map((item) => {
              var listaDevolucaoClientes = ({
                nome_cliente: item.nome_cliente,
                valor_venda: item.valor_venda.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                valor_devolucao: item.valor_devolucao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                porcentagem: item.porcentagem.toFixed(2).toString().replace('.', ',') + '%',
              })

              return listaDevolucaoClientes
            })

            for (var i = 0; i < 35 && i < this.devolucaoClientes.length; i++) {
              this.devolucaoClientesPrint.push(this.devolucaoClientes[i])
            }
          } else if (resposta.data.msg === 'Não há dados de devolução no período selecionado') {
            this.devolucaoClientes = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false

          eventEmit.$emit('envio-devolucao', this.headersDevolucaoClientes, this.devolucaoClientes)
        })
      },

      enableTexto (value) {
        var i = 0

        this.orientacao = JSON.parse(localStorage.getItem('orientacaoPartipantes'))

        this.codigo = value

        for (i in this.orientacao) {
          if (this.orientacao[i].codigo === '167') {
            this.textoParticpantesDevolucao = this.orientacao[i].descricao
          }
        }
      },

      getColor (value) {
        var porcentagem = parseFloat(value.replace(',', '.'))

        if (porcentagem >= 100) {
          return 'color: red'
        } else {
          return 'color: green'
        }
      },
    },
  }
</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 360px)
  and (max-device-width : 680px) {
    #headersDevolucaoClientes {
      width: 100% !important;
    }

     #idTable {
      max-height: 500px;
    }

    #dadoMovimentacao {
      font-size: 8.5px !important;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #headersDevolucaoClientes {
      max-width: 100%;
    }
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
  }

   #dadoMovimentacao {
    font-size: 12px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  #listItemDevolucaoParticipantes {
    margin: -2rem 0 0 -1rem;
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  /* #devolucaoClientePrint {
    margin: 52rem 0 0 0 !important
  } */
</style>
